import React from "react";
import { iconStyles } from "./iconStyles";
export function DockLeftIcon() {
    return (<svg className={iconStyles} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M4 10C4 7.79086 5.79086 6 8 6H32C34.2091 6 36 7.79086 36 10V30C36 32.2091 34.2091 34 32 34H8C5.79086 34 4 32.2091 4 30V10ZM15 9H32C32.5523 9 33 9.44772 33 10V30C33 30.5523 32.5523 31 32 31H15V9ZM12 9H8C7.44772 9 7 9.44772 7 10V30C7 30.5523 7.44772 31 8 31H12V9Z"/>
        </svg>);
}
